import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
// Icons
import Logo_black from "../assets/logo.png";
import betaImg from "../assets/sidebar/beta.png";
import SideBarData from "../assets/Data/sidebar-menu-option";
import { ZustandStore } from "../../store/zustand-store";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import AddProjectStore from "../../store/AddProjectStore";

const themes = {
  light: {
    logo: Logo_black,
    sidebar: {
      backgroundColor: "rgb(247, 247, 247)",
      color: "#2B2B2B",
    },
    menu: {
      menuContent: "rgb(247, 247, 247)",
      icon: "#2B2B2B",
      hover: {
        backgroundColor: "#6A3BE41A",
        color: "#6A3BE4",
      },
      active: {
        backgroundColor: "#6A3BE41A",
        color: "#6A3BE4",
        fontWeight: 500,
      },
      disabled: {
        color: "#C4C7CF",
      },
    },
  },
};

const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const StyledSidebarHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  > div {
    width: 100%;
    overflow: hidden;
  }
`;

const SideBar = ({ type }) => {
  const theme = "light";
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const sidebarArr = SideBarData();
  const { isSidebarOpen, setSidebarOpen } = ZustandStore((state) => state);
  const { appliedWhiteLable } = AddProjectStore((state) => state);

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isSidebarOpen]);

  const menuItemStyles = {
    root: {
      fontSize: "15px",
      fontWeight: 600,
      color: themes[theme].sidebar.color,
      borderBottom: "1px solid white",
    },
    icon: {
      color: themes[theme].menu.icon,
      borderRadius: "50%",
      transition: "background-color 0.3s",
    },
    button: {
      backgroundColor: themes[theme].menu.menuContent,
      borderRadius: "0px",
      marginBottom: "1px",
      width: "100%",
      borderRight: "4px solid transparent",
      "&:hover": {
        backgroundColor: themes[theme].menu.hover.backgroundColor,
        color: themes[theme].menu.hover.color,
        borderColor: "#6A3BE4",
      },
      "&.ps-active": {
        backgroundColor: themes[theme].menu.active.backgroundColor,
        color: themes[theme].menu.active.color,
        borderColor: "#6A3BE4",
        "& .menu-item-icon": {
          backgroundColor: hexToRgba(
            themes[theme].menu.active.backgroundColor,
            1
          ),
        },
      },
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : undefined,
      whiteSpace: "normal",
    }),
    SubMenuExpandIcon: {
      span: {
        width: "10px",
        height: "10px",
      },
    },
    subMenuContent: () => ({
      backgroundColor: "#ebebeb",
      whiteSpace: "normal !important", // Ensure wrapping
      overflowWrap: "break-word !important", // Break long words
      maxWidth: "100% !important",
    }),
  };
  if (pathname === "/upgrade") return null;
  return (
    <Sidebar
      breakPoint="md"
      backgroundColor={themes[theme].sidebar.backgroundColor}
      rootStyles={{
        color: themes[theme].sidebar.color,
      }}
      toggled={isSidebarOpen}
      onBackdropClick={() => setSidebarOpen(false)}
      width="230px"
      style={{ borderRight: "1px solid #C4C7CF", whiteSpace: "normal" }}
      className="dr-sidebar"
    >
      {type === "userNavItem" ? null : (
        <StyledSidebarHeader>
          <div className="nv-logo">
            <Link to="/dashboard">
              <img src={themes[theme].logo} alt="RanksPro.io" />
            </Link>
          </div>
        </StyledSidebarHeader>
      )}
      <div style={{ flex: 1, marginBottom: "25px" }}>
        <Menu menuItemStyles={menuItemStyles}>
          {sidebarArr[type]?.map((item, index) => {
            if (item.sub_list && item.sub_list.length > 0) {
              return (
                <SubMenu
                  key={`sub-menu-list-0-${index}-${item?.name}`}
                  label={item.name}
                  style={{
                    marginRight: "10px",
                    whiteSpace: "normal",
                    border: "none",
                  }}
                  active={item.path.includes(pathname)}
                >
                  {item.sub_list.map((subItem, subIndex) => (
                    <MenuItem
                      style={{
                        paddingLeft: "16px",
                        color: subItem.path.includes(pathname)
                          ? "#6A3BE4"
                          : themes[theme].sidebar.color,
                        backgroundColor: "#ebebeb",
                        textDecoration: "none",
                      }}
                      key={`sub-menu-list-${subIndex}-${subItem?.name}`}
                      component={
                        subItem?.openInNewTab ? (
                          <a
                            href={subItem.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              whiteSpace: "normal",
                            }}
                          >
                            <span style={{ whiteSpace: "normal" }}>
                              - {subItem.name}
                            </span>
                          </a>
                        ) : (
                          <Link to={subItem.url} />
                        )
                      }
                      active={subItem.path.includes(pathname)}
                    >
                      {subItem?.icon && (
                        <img
                          src={subItem.icon}
                          alt={subItem.name}
                          style={{ width: "24px", objectFit: "contain" }}
                        />
                      )}

                      <span style={{ whiteSpace: "normal" }}>
                        {subItem.name}
                      </span>
                    </MenuItem>
                  ))}
                </SubMenu>
              );
            } else {
              return (
                <MenuItem
                  style={{
                    paddingLeft: "16px",
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                  }}
                  key={`sub-menu-list-${item?.name}`}
                  active={item.path.includes(pathname)}
                  component={
                    item?.openInNewTab ? (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span style={{ whiteSpace: "normal" }}>
                          {item.name}
                        </span>
                      </a>
                    ) : (
                      <Link to={item.url} />
                    )
                  }
                >
                  {item?.icon && (
                    <img
                      src={item.icon}
                      alt={item.name}
                      style={{ width: "24px", objectFit: "contain" }}
                    />
                  )}
                  <span style={{ whiteSpace: "normal" }}> {item.name}</span>
                  {item.name === "Site Audit" && (
                    <img
                      src={betaImg}
                      alt="beta"
                      className="ms-2"
                      style={{
                        width: "40px",
                        objectFit: "contain",
                        marginBottom: "6px",
                      }}
                    />
                  )}
                </MenuItem>
              );
            }
          })}
          {appliedWhiteLable?.show_affiliate && (
            <a
              href={"https://rankspro-io.getrewardful.com/signup"}
              target="_blank"
              style={{
                padding: "0 10px 0px 10px",
              }}
            >
              <button
                style={{
                  maxWidth: "210px",
                  whiteSpace: "normal",
                  width: "90%",
                }}
                className="mt-3"
              >
                {type === "adsyNavItem"
                  ? "Earn 30% Commission"
                  : t("sidebar.user.earn_commission.title")}
              </button>
            </a>
          )}
        </Menu>
      </div>
    </Sidebar>
  );
};

export default React.memo(SideBar);
